<div
	class="bp-feature builder-cover-bg"
	[style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : 'url(' + data.bg_thumbnail.url + ')'"
>
	<div
		class="bp-feature-holder builder-default-layout"
		[style.max-width]="desktopWidth + 'px'"
	>
		<div
			*ngFor="let feature of trustedFeatures"
			class="feature"
		>
			<div class="feature-row" *ngIf="feature.lhs">
				<div cols="12" md="6">
					<a [href]="feature.url" target="_blank">
						<img
							class="d-md-flex d-md-none"
							[class.large-only]="feature.thumbnail_mobile && feature.thumbnail_mobile.url"
							[src]="feature.thumbnail.url"
							:lazy-src="feature.thumbnail.thumb_url"
							[alt]="feature.thumbnail.custom_properties.alt_text"
							[style.max-height]="'400px'"
							[height]="feature.thumbnail.height"
							[width]="feature.thumbnail.width"
						>
						<img *ngIf="feature.thumbnail_mobile && feature.thumbnail_mobile.url"
							class="small-only"
							[src]="feature.thumbnail_mobile.url"
							[alt]="feature.thumbnail_mobile.custom_properties.alt_text"
							[style.max-height]="'400px'"
							[height]="feature.thumbnail_mobile.height"
							[width]="feature.thumbnail_mobile.width"
						>
					</a>
				</div>
				<div cols="12" md="6">
					<h2
						[style.text-align]="feature.props && feature.props[0] && feature.props[0].align ? feature.props[0].align : 'initial'"
						[style.color]="feature.props && feature.props[0] && feature.props[0].color ? feature.props[0].color : 'initial'"
						[style.font-weight]="feature.props && feature.props[0] && feature.props[0].style ? feature.props[0].style : 'initial'"
						[style.font-size]="feature.props && feature.props[0] && feature.props[0].size ? feature.props[0].size : 'initial'"
					>
						{{ feature.title }}
					</h2>
					<div class="desc" [innerHTML]="feature.trustedDesc"></div>
				</div>
			</div>
			<div class="feature-row small-reverse" *ngIf="!feature.lhs">
				<div
					cols="12"
					md="6"
					class="order-0 order-md-0 order-lg-0 order-xl-0 order-sm-1"
				>
					<h2
						[style.text-align]="feature.props && feature.props[0] && feature.props[0].align ? feature.props[0].align : 'initial'"
						[style.color]="feature.props && feature.props[0] && feature.props[0].color ? feature.props[0].color : 'initial'"
						[style.font-weight]="feature.props && feature.props[0] && feature.props[0].style ? feature.props[0].style : 'initial'"
						[style.font-size]="feature.props && feature.props[0] && feature.props[0].size ? feature.props[0].size : 'initial'"
					>
						{{ feature.title }}
					</h2>
					<div class="desc" [innerHTML]="feature.trustedDesc"></div>
				</div>
				<div
					cols="12"
					md="6"
					class="order-1 order-md-1 order-lg-1 order-xl-1 order-sm-0"
				>
					<a [href]="feature.url" target="_blank">
						<img
							class="d-md-flex d-md-none"
							[src]="feature.thumbnail.url"
							[class.large-only]="feature.thumbnail_mobile && feature.thumbnail_mobile.url"
							:lazy-src="feature.thumbnail.thumb_url"
							[alt]="feature.thumbnail.custom_properties.alt_text"
							[style.max-height]="'400px'"
							[height]="feature.thumbnail.height"
							[width]="feature.thumbnail.width"
						>
						<img *ngIf="feature.thumbnail_mobile && feature.thumbnail_mobile.url"
							class="small-only"
							[src]="feature.thumbnail_mobile.url"
							[alt]="feature.thumbnail_mobile.custom_properties.alt_text"
							[style.max-height]="'400px'"
							[height]="feature.thumbnail_mobile.height"
							[width]="feature.thumbnail_mobile.width"
						>
					</a>
				</div>
			</div>
		</div>
	</div>
</div>